import { HttpService } from "@/core";

import {
  FollowPageReq,
  FollowPageResp,
  FollowBaseReq,
  FollowDetailPageReq,
  FollowDetailPageResp,
} from "./follow.interface";

export class FollowService {
  static usePageApi() {
    const api = (params: FollowPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project_trace/page",
        params,
      });
    return HttpService.usePagination<FollowPageResp>(api);
  }

  static useCreateApi() {
    const api = (data: FollowBaseReq) =>
      HttpService.axios({
        method: "POST",
        url: "/project_trace",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDetailPageApi() {
    const api = (params: FollowDetailPageReq) =>
      HttpService.axios({
        method: "get",
        url: "/project_trace/detail/page",
        params,
      });
    return HttpService.useRequest<FollowDetailPageResp>(api);
  }
}
